import React, { useState } from 'react';
import PropTypes from 'prop-types';

import styles from "../styles/login.module.css";

function Login(props) {
  // ---------------------------------------------------------------- state and hooks

  const [username, setUsername] = useState(null);
  const [password, setPassword] = useState(null);
  
  // ---------------------------------------------------------------- logic

  function login() {
    sessionStorage.setItem('user', username);
    sessionStorage.setItem('password', password);
    props.selectUser(username);
  }
  // ---------------------------------------------------------------- render

  return (
    <div className={styles.container}>
      <h1 className={styles.header}>Login</h1>

      <div style={{display: 'flex'}}>
        <form
          style={{ margin: 'auto' }}
          onSubmit={login}>
          <div>
            <label htmlFor='username' className={styles.subheader}>Username</label>
            <input
              className={styles.input}
              type='text'
              id='username'
              name='username'
              onChange={(e) => setUsername(e.target.value)}
            />
          </div>

          <br />

          <div>
            <label htmlFor='password' className={styles.subheader}>Password</label>
            <input
              className={styles.input}
              type='password'
              id='password'
              name='password'
              onChange={(e) => setPassword(e.target.value)}
            />
          </div>

          <br />

          <div>
            <input
              className={styles.goButton}
              type='submit'
              value='Go'
            />
          </div>
        </form>
      </div>
    </div>
  );
}

Login.propTypes = {
  selectUser: PropTypes.func,
};

export default Login;
